import { ATTACHMENT_FILES as NAME } from '../../constants';

export { DMS_MODULE, ATTACHMENT_FILES as NAME } from '../../constants';
export const DEPENDENT_TABLES = <const>[NAME];

export const FILE_TYPE = 'image-document';
